module.exports = __webpack_public_path__ + "img/reddot.a6421c35.png";